export const USERS_LIST_REQUEST = "USERS_LIST_REQUEST"
export const USERS_LIST_SUCCESS = "USERS_LIST_SUCCESS"
export const USERS_LIST_FAIL = "USERS_LIST_FAIL"